import React, { useState } from 'react'
import PropTypes from 'prop-types'
import useSimpleList from 'hooks/useSimpleList'
import {
  requestPaymentPlanCreate,
  requestPaymentPlanUpdate,
  requestPaymentPlanDestroy,
} from 'requests/payment-plans'
import { Edit, Delete } from '@material-ui/icons'
import { EMPTY_PAYMENT_PLAN } from 'constants/objects/payment-plan'
import { SlideDialog } from 'ui-components/SlideDialog'
import { Confirm } from 'ui-components/Confirm'
import { Button } from 'ui-components/Button'
import { CardList } from 'ui-components/CardList'
import { DescItemList } from 'ui-components/DescItemList'
import { DescList } from 'ui-components/DescList'
import Form from 'components/PaymentPlan/Form/Form'
import { Item, ButtonContainer } from './styles'

export default function PaymentPlansList({ paymentMethod, onSavePlan }) {
  const [toShowDeleteConfirm, setToShowDeleteConfirm] = useState(false)
  const [planToDelete, setPlanToDelete] = useState()

  const [paymentPlans, listState, listActions] = useSimpleList({
    defaultList: paymentMethod.attributes.payment_plans?.data || [],
    requestCreate: (params) => (
      (async function request() {
        const resp = await requestPaymentPlanCreate({
          paymentMethodId: paymentMethod.id,
          params,
        })

        return resp
      }())
    ),
    requestUpdate: (id, params) => (
      (async function request() {
        const resp = await requestPaymentPlanUpdate({
          id,
          params,
          paymentMethodId: paymentMethod.id,
        })

        return resp
      }())
    ),
    onSave: onSavePlan,
    requestDestroy: (id) => (
      (async function request() {
        const resp = await requestPaymentPlanDestroy({
          id,
          paymentMethodId: paymentMethod.id,
        })

        return resp
      }())
    ),
  })

  const onAddPaymentPlan = () => {
    listActions.onToggleForm(true)
    listActions.selectItem(EMPTY_PAYMENT_PLAN)
  }

  const handleConfirmDestroy = (paymentPlan) => {
    setPlanToDelete(paymentPlan)
    setToShowDeleteConfirm(true)
  }

  const handleSave = (params) => {
    listActions.save(params)
  }

  const handleDestroy = () => {
    listActions.destroy(planToDelete.id)
  }

  const renderForm = () => (
    <Form
      paymentPlan={listState.currentItem || EMPTY_PAYMENT_PLAN}
      onCancel={() => listActions.onToggleForm(false)}
      onSave={handleSave}
      responseError={listState.responseError}
    />
  )

  const renderPaymentPlan = (paymentPlan) => (
    <DescList key={`payment-plan-${paymentPlan.id}`}>
      <Item>
        <DescItemList label="Parcela">
          {paymentPlan.attributes.installment_number}
        </DescItemList>
        <DescItemList label="Descrição">
          {paymentPlan.attributes.description}
        </DescItemList>
        <Button
          buttonType="icon"
          onClick={() => listActions.selectItem(paymentPlan)}
        >
          <Edit />
        </Button>
        <Button
          buttonType="icon"
          onClick={() => handleConfirmDestroy(paymentPlan)}
        >
          <Delete />
        </Button>
      </Item>
    </DescList>
  )

  return (
    <div>
      <Confirm
        open={toShowDeleteConfirm}
        title="Remover item"
        onCancel={() => setToShowDeleteConfirm(false)}
        onConfirm={handleDestroy}
        cancelButtonText="Cancelar"
        confirmButtonText="Sim, remover item"
        requesting={listActions.saving}
        type="warning"
      >
        <p>Deseja realmente remover este item?</p>
      </Confirm>

      <SlideDialog
        open={listState.showForm}
        onClose={() => listActions.onToggleForm(false)}
      >
        { renderForm() }
      </SlideDialog>

      <CardList>
        { paymentPlans.map(renderPaymentPlan) }

        <ButtonContainer>
          <Button onClick={onAddPaymentPlan}>
            Adicionar parcela
          </Button>
        </ButtonContainer>
      </CardList>
    </div>
  )
}

PaymentPlansList.propTypes = {
  paymentMethod: PropTypes.objectOf(PropTypes.any).isRequired,
  onSavePlan: PropTypes.func.isRequired,
}
